import emoji1Base64 from '../../assets/chat_emoji/1.svg'
import emoji2Base64 from '../../assets/chat_emoji/2.svg'
import emoji3Base64 from '../../assets/chat_emoji/3.svg'
import emoji4Base64 from '../../assets/chat_emoji/4.svg'
import emoji5Base64 from '../../assets/chat_emoji/5.svg'
import emoji6Base64 from '../../assets/chat_emoji/6.svg'
import emoji7Base64 from '../../assets/chat_emoji/7.svg'
import emoji8Base64 from '../../assets/chat_emoji/8.svg'
import emoji9Base64 from '../../assets/chat_emoji/9.svg'
import emoji10Base64 from '../../assets/chat_emoji/10.svg'
import emoji11Base64 from '../../assets/chat_emoji/11.svg'
import emoji12Base64 from '../../assets/chat_emoji/12.svg'
import emoji13Base64 from '../../assets/chat_emoji/13.svg'
import emoji14Base64 from '../../assets/chat_emoji/14.svg'
import emoji15Base64 from '../../assets/chat_emoji/15.svg'
import emoji16Base64 from '../../assets/chat_emoji/16.svg'
import emoji17Base64 from '../../assets/chat_emoji/17.svg'
import emoji18Base64 from '../../assets/chat_emoji/18.svg'
import emoji19Base64 from '../../assets/chat_emoji/19.svg'
import emoji20Base64 from '../../assets/chat_emoji/20.svg'
import emoji21Base64 from '../../assets/chat_emoji/21.svg'
import emoji22Base64 from '../../assets/chat_emoji/22.svg'
import emoji23Base64 from '../../assets/chat_emoji/23.svg'
import emoji24Base64 from '../../assets/chat_emoji/24.svg'
import emoji25Base64 from '../../assets/chat_emoji/25.svg'
import emoji26Base64 from '../../assets/chat_emoji/26.svg'
import emoji27Base64 from '../../assets/chat_emoji/27.svg'
import emoji28Base64 from '../../assets/chat_emoji/28.svg'
import emoji29Base64 from '../../assets/chat_emoji/29.svg'
import emoji30Base64 from '../../assets/chat_emoji/30.svg'
import emoji31Base64 from '../../assets/chat_emoji/31.svg'
import emoji32Base64 from '../../assets/chat_emoji/32.svg'
import emoji33Base64 from '../../assets/chat_emoji/33.svg'
import emoji34Base64 from '../../assets/chat_emoji/34.svg'
import emoji35Base64 from '../../assets/chat_emoji/35.svg'
import emoji36Base64 from '../../assets/chat_emoji/36.svg'
import emoji37Base64 from '../../assets/chat_emoji/37.svg'
import emoji38Base64 from '../../assets/chat_emoji/38.svg'
import emoji39Base64 from '../../assets/chat_emoji/39.svg'
import emoji40Base64 from '../../assets/chat_emoji/40.svg'
import emoji41Base64 from '../../assets/chat_emoji/41.svg'
import emoji42Base64 from '../../assets/chat_emoji/42.svg'
import emoji43Base64 from '../../assets/chat_emoji/43.svg'
import emoji44Base64 from '../../assets/chat_emoji/44.svg'
import emoji45Base64 from '../../assets/chat_emoji/45.svg'
import emoji46Base64 from '../../assets/chat_emoji/46.svg'
import emoji47Base64 from '../../assets/chat_emoji/47.svg'
import emoji48Base64 from '../../assets/chat_emoji/48.svg'
import emoji49Base64 from '../../assets/chat_emoji/49.svg'
import emoji50Base64 from '../../assets/chat_emoji/50.svg'
import emoji51Base64 from '../../assets/chat_emoji/51.svg'
import emoji52Base64 from '../../assets/chat_emoji/52.svg'
import emoji53Base64 from '../../assets/chat_emoji/53.svg'
import emoji54Base64 from '../../assets/chat_emoji/54.svg'
import emoji55Base64 from '../../assets/chat_emoji/55.svg'
import emoji56Base64 from '../../assets/chat_emoji/56.svg'

const dataUrl = (base64: string): string => `data:image/svg+xml;base64,${base64}`

export const arkmeEmojiAssetUrls: readonly string[] = Object.freeze([
  dataUrl(emoji1Base64),
  dataUrl(emoji2Base64),
  dataUrl(emoji3Base64),
  dataUrl(emoji4Base64),
  dataUrl(emoji5Base64),
  dataUrl(emoji6Base64),
  dataUrl(emoji7Base64),
  dataUrl(emoji8Base64),
  dataUrl(emoji9Base64),
  dataUrl(emoji10Base64),
  dataUrl(emoji11Base64),
  dataUrl(emoji12Base64),
  dataUrl(emoji13Base64),
  dataUrl(emoji14Base64),
  dataUrl(emoji15Base64),
  dataUrl(emoji16Base64),
  dataUrl(emoji17Base64),
  dataUrl(emoji18Base64),
  dataUrl(emoji19Base64),
  dataUrl(emoji20Base64),
  dataUrl(emoji21Base64),
  dataUrl(emoji22Base64),
  dataUrl(emoji23Base64),
  dataUrl(emoji24Base64),
  dataUrl(emoji25Base64),
  dataUrl(emoji26Base64),
  dataUrl(emoji27Base64),
  dataUrl(emoji28Base64),
  dataUrl(emoji29Base64),
  dataUrl(emoji30Base64),
  dataUrl(emoji31Base64),
  dataUrl(emoji32Base64),
  dataUrl(emoji33Base64),
  dataUrl(emoji34Base64),
  dataUrl(emoji35Base64),
  dataUrl(emoji36Base64),
  dataUrl(emoji37Base64),
  dataUrl(emoji38Base64),
  dataUrl(emoji39Base64),
  dataUrl(emoji40Base64),
  dataUrl(emoji41Base64),
  dataUrl(emoji42Base64),
  dataUrl(emoji43Base64),
  dataUrl(emoji44Base64),
  dataUrl(emoji45Base64),
  dataUrl(emoji46Base64),
  dataUrl(emoji47Base64),
  dataUrl(emoji48Base64),
  dataUrl(emoji49Base64),
  dataUrl(emoji50Base64),
  dataUrl(emoji51Base64),
  dataUrl(emoji52Base64),
  dataUrl(emoji53Base64),
  dataUrl(emoji54Base64),
  dataUrl(emoji55Base64),
  dataUrl(emoji56Base64),
])
